import { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import Loading from "../Loading/Loading";
import WhatsAppModal from "../WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { getUtmParams, openWhatsAppConsulta } from "../../config/whatsappConfig";

const Slider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  let location = useLocation();

  // console.log(location.pathname.split("/").pop(), "el tipo");

  useEffect(() => {
    const obtenerDatos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = sessionStorage.getItem("sliders-ford");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setBanners(JSON.parse(datosLocales));
        setLoading(false);
      } else {
        const db = getFirestore();
        try {
          const data = await db.collection("sliders-ford").get();
          const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          // Guardar los datos obtenidos en localStorage
          sessionStorage.setItem("sliders-ford", JSON.stringify(arrayData));
          // Actualizar el estado con los nuevos datos
          setBanners(arrayData);
        } catch (error) {
          if (error?.code !== "cancelled" && error?.message !== "cancelled") {
            console.error("Error al obtener datos de Firestore: ", error);
          }
        } finally {
          // Asegurar que setLoading se establezca en false independientemente del resultado
          setLoading(false);
        }
      }
    };

    obtenerDatos();
    // La dependencia [] significa que este efecto solo se ejecutará una vez, cuando el componente se monte.
  }, []);

  //console.log(banners[0]);

  const handleModal = () => {
    setOpen(true);
  };

  const handleModalSubmit = async (values) => {
    setSubmitting(true);
    try {
      const { utm_source, utm_medium, utm_campaign } = getUtmParams();
      await updateData({ ...values, utm_source, utm_medium, utm_campaign });
      setOpen(false);
      openWhatsAppConsulta();
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setSubmitting(false);
    }
  };

  return loading ? (
    <Loading styles="mt-5 pt-5 pb-5" />
  ) : (
    <>
      {location.pathname.split("/").pop() === "todos" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] &&
                banners[0].desktop.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 img-fluid cursor-pointer"
                      src={item.slider}
                      alt="Montironi Peugeot"
                      onClick={handleModal}
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] &&
                banners[0].mobile.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 img-fluid cursor-pointer"
                      src={item.slider}
                      alt="Montironi Peugeot"
                      onClick={handleModal}
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "plan" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.plan === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.plan === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.plan === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.plan === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "grandesclientes" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.grandesclientes === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.grandesclientes === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.grandesclientes === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.grandesclientes === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "convencional" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.convencional === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.convencional === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.convencional === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.convencional === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={handleModal}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={handleModal}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}

      <WhatsAppModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleModalSubmit}
        loading={submitting}
      />
    </>
  );
};

export default Slider;

